import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { init } from "@noriginmedia/norigin-spatial-navigation";
// Using new MnbPlayer - custom player built from scratch
import PlayerContent from "../../player/PlayerContent";
import "../../player/styles/player.css";

init({
  debug: false,
  visualDebug: false,
});

const GlobalStyle = createGlobalStyle`
  ::-webkit-scrollbar {
    display: none;
  }
`;

const AppContainer = styled.div`
  background: #121212;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
`;

export default function SpitialPlyer({ data }) {
  return (
    <AppContainer>
      <GlobalStyle />
      <PlayerContent data={data} />
    </AppContainer>
  );
}
